import { Divider, Paper, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Background from 'ui/atoms/Background/Background';
import ComponentWrapper from '../ComponentWrapper/ComponentWrapper';

const AdminAccountCreatedPage: React.FC<React.PropsWithChildren> = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);
  const isExtraSmallScreen = useMediaQuery('(min-width: 0px) and (max-width:627px)');
  const isSmallScreen = useMediaQuery('(min-width: 628px) and (max-width:643px)');
  const isMediumScreen = useMediaQuery('(min-width: 644px) and (max-width:663px)');

  const getPaperPadding = () => {
    if (isExtraSmallScreen || isSmallScreen) return '48px 24px';
    if (isMediumScreen) return '48px 40px';
    return '48px 80px';
  };

  const getPaperWidth = () => {
    if (isExtraSmallScreen) {
      return 'calc(100vw - 80px)';
    }
    if (isSmallScreen) {
      return '520px';
    }
    if (isMediumScreen) {
      return '552px';
    }
    return '632px';
  };

  useEffect(() => {
    let intervalId = null;

    if (countdown > 0) {
      intervalId = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [countdown]);

  useEffect(() => {
    if (countdown === 0) {
      navigate('/');
    }
  }, [countdown]);

  return (
    <ComponentWrapper width="100vw" height="100vh" justifyContent="center" alignItems="center">
      <Background id="background" />
      <Paper
        elevation={3}
        data-testid="login-window"
        id="login-window"
        style={{
          alignSelf: 'center',
          justifySelf: 'center',
          padding: getPaperPadding(),
          width: getPaperWidth(),
          borderRadius: '10px'
        }}
      >
        <ComponentWrapper flexDirection="column" gap="16px">
          <Typography variant="h4">Admin account created</Typography>
          <Divider />
          <Typography variant="body1">
            In a few seconds we will redirect you to the login page where you can use your new credentials to enter the
            ATLAS Portal.
          </Typography>
          <Typography variant="h5" alignSelf="center">
            {countdown}
          </Typography>
        </ComponentWrapper>
      </Paper>
    </ComponentWrapper>
  );
};

export default AdminAccountCreatedPage;
